"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalCancel = exports.modalCancelEvent = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const emitter = new eventemitter3_1.default();
exports.modalCancelEvent = {
    on: emitter.on.bind(emitter, "cancelModal"),
    off: emitter.off.bind(emitter, "cancelModal"),
    emit: emitter.emit.bind(emitter, "cancelModal"),
};
const useModalCancel = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const pagePath = location.pathname;
    (0, react_1.useEffect)(() => {
        exports.modalCancelEvent.emit();
    }, [pagePath]);
};
exports.useModalCancel = useModalCancel;
